export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/wasm-module-2.4d80831ccafd1552.js");
}
